/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import {
  IAgentPlugin,
  IPluginMethodMap,
} from "@vlinder-web/plugin-agent-service-react";
import config from "../config/appCardList.config.json";
import { GraphqlServerModule } from "@vlinder-web/graphql-server-module-react";
import { GET_CREDENTIAL_TEMPLATES_LIST } from "../graphql";
import { VApplication } from "../../../application";

import { getUserId } from "../../../pages/AttestCertificateReviewList/provider";

import { toHeaderCase } from "js-convert-case";

const getGraphQLModule = () => {
  const app = VApplication.getInstance();
  return app.getSync("services.GraphqlServerModule") as GraphqlServerModule;
};

export interface IGetCredentialsListProps {
  offset?: number;
  size?: number;
  criteria?:any;
}

export interface IAppCardListMethods extends IPluginMethodMap {
  getAppCardListProps(args: IGetCredentialsListProps): Promise<any>;
}

export class AppCardListService implements IAgentPlugin {
  readonly methods: IAppCardListMethods;

  constructor() {
    this.methods = {
      getAppCardListProps: this.getProps.bind(this),
    };
  }

  async getProps(args: IGetCredentialsListProps) {
    const graphqlModule = getGraphQLModule();
    const client = graphqlModule.getClient("graphql-gateway");
    const {userId}=getUserId()
    try {
      if (client) {
        const res = await client.query({
          query: GET_CREDENTIAL_TEMPLATES_LIST,
          variables: {
         
              offset: args?.offset ?? 0,
              size: args?.size ?? 10,
              criteria:args?.criteria,
              userId: userId,
            
          },
          fetchPolicy: "network-only",
        });
        console.log('7Self2',res?.data)
        if (res?.data?.getListOfCredentialSchemaReview) {
          let _templateData = this.formatTemplateList(
            res?.data?.getListOfCredentialSchemaReview?.data
          );
          return {
            appCardList: _templateData,
            isEmpty: res?.data?.getListOfCredentialSchemaReview?.data?.length <= 0,
            // studentGroup: holderGroups,
            activePage: res?.data?.getListOfCredentialSchemaReview?.currentPage,
            pageSize: res?.data?.getListOfCredentialSchemaReview?.pageSize,
            totalCount: res?.data?.getListOfCredentialSchemaReview?.totalCount,
            totalPages: res?.data?.getListOfCredentialSchemaReview?.totalPages,
          };
        }
      }
    } catch (err: any) {
      console.log(`error in table data`, err);
      return {
        isEmpty: true,
      };
    }
  }

  private formatTemplateList(data: any) {
    let _rowData: any =
      Array.isArray(data) &&
      data.map((item: any) => {
        return {
          ...item,
          appCardId: item?.id,
          appCardImage: item?.logo,
          appCardTitle: item?.name ? toHeaderCase(item?.name) : "",
          appCardDescription: item?.description,
        };
      });

    return _rowData;
  }
}
